import * as React from 'react';
import { Flex, Box } from '@lightspeed/flame/Core';
import { Button } from '@lightspeed/flame/Button';
import { Text } from '@lightspeed/flame/Text';

import Decimal from 'app/src/data/base/Decimal';
import Localize from 'app/src/localize/Localize';
import Format from 'app/src/data/Format';
import PaymentTypeManager from 'app/src/payments/PaymentTypeManager';
import { usePaymentContext } from '../Store/PaymentState';
import { UserDefinedPaymentTypeForm } from '../components/UserDefinedPaymentTypeForm';

export const CashInputForm = () => {
  const cashPaymentTypeID = PaymentTypeManager.getPaymentIdForType(PaymentTypeManager.Types.CASH);
  const [cashRemainder, setCashBalance] = React.useState(new Decimal(0));
  const { denominations, saleManager, paymentMethod, onPaymentChanged } = usePaymentContext();

  // /**
  //  * Event handler for when a cash denomination is clicked.
  //  *
  //  * @param denomination {string}  The value of the cash denomination to be added to the payments.
  //  */
  const onDenominationClicked = React.useCallback(
    denomination => {
      const cashDenominationClicked = new Decimal(denomination);
      const currentCashAmount = paymentMethod[cashPaymentTypeID].amount;
      const updatedCashAmount = cashDenominationClicked.plus(currentCashAmount);
      onPaymentChanged(cashPaymentTypeID, updatedCashAmount);
    },
    [cashPaymentTypeID, onPaymentChanged, paymentMethod]
  );

  React.useEffect(() => {
    if (saleManager && paymentMethod[cashPaymentTypeID]) {
      const pendingChange: Decimal = saleManager.pendingChange;
      if (!pendingChange.isEqualTo(cashRemainder)) {
        setCashBalance(pendingChange);
      }
    }
  }, [cashPaymentTypeID, cashRemainder, paymentMethod, saleManager]);

  return (
    <>
      <Flex justifyContent="center" mt={4} flexWrap="wrap">
        {denominations.map(({ name, value }: TSFixMe) => (
          <Box mr={1} mb={1} key={`cashBill${value}Button`}>
            <Button
              data-automation="cashBillButton"
              id={`cashBill${value}Button`}
              name={`cashBill${value}Button`}
              value={value}
              onClick={() => onDenominationClicked(value)}
            >
              {name}
            </Button>
          </Box>
        ))}
      </Flex>
      <UserDefinedPaymentTypeForm name="Cash" paymentTypeID={cashPaymentTypeID} />
      {cashRemainder.isGreaterThan(0) && (
        <Flex>
          <Text pr={1} textTransform="capitalize">
            {Localize.translate('Change')}
          </Text>
          <div className="payment-amount">
            <span id="cash_remainder_balance" role="cell" aria-label="cash remainder balance">
              {Format.formatMoney(cashRemainder, 0, false)}
            </span>
          </div>
        </Flex>
      )}
    </>
  );
};
